import { render, staticRenderFns } from "./TabelaContatosExcluidos.vue?vue&type=template&id=1de484fe&scoped=true"
import script from "./TabelaContatosExcluidos.vue?vue&type=script&lang=js"
export * from "./TabelaContatosExcluidos.vue?vue&type=script&lang=js"
import style0 from "./TabelaContatosExcluidos.vue?vue&type=style&index=0&id=1de484fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de484fe",
  null
  
)

export default component.exports